import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import router from './router/router';
import httphelper from './assets/unit/HttpHelper';
import md5 from 'js-md5';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import msgmodal from './views/components/msgModal/msgset';
import paginationset from './views/components/page/paginationset';
import videopage from './views/components/video/videomodal';
import customDirective from './views/directives/directive';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import $loading from './views/components/Loading/index';
import BaiduMap from 'vue-baidu-map';
import Ellipsis from './assets/unit/ellipsis';
import routerlist from './router/menu';
import customModal from './views/components/customModal/index';
import VueCookies from 'vue-cookies';
import SlideVerify from 'vue-monoplasty-slide-verify';
import iconfont from './assets/css/iconfont.css';
import formatter from './assets/unit/unit';
import publicunit from './assets/unit/publicunit';
import Vant from 'vant';
import 'vant/lib/index.css';
import h5weixinShare from './assets/unit/h5weixinShare.js';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import wx from 'weixin-js-sdk';

Vue.prototype.wx = wx;
Vue.use(preview);
Vue.prototype.formatter = formatter;
Vue.prototype.publicunit = publicunit;
Vue.prototype.iconfont = iconfont;
Vue.prototype.isDebug = false;
Vue.prototype.ellipsis = Ellipsis;
Vue.prototype.$md5 = md5;
Vue.prototype.httphelper = httphelper;
Vue.prototype.$h5weixinshare = h5weixinShare;
Vue.prototype.routerlist = routerlist;
Vue.use(VueRouter);
Vue.use(VueAwesomeSwiper);
Vue.use(msgmodal).use(paginationset).use(customDirective).use(videopage).use(customModal).use(VueCookies);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use($loading);
Vue.config.productionTip = false;
Vue.use(BaiduMap, {
  // ak: "u8n7EbYE9SUmhF7WKOBu8xtbTDNiY9ex"
  ak: 'FfZTF83I4oMVZwpsqCNFlRsu3XssUYR5',
});
Vue.directive('myfocus', {
  inserted: (el, binding) => {
    if (binding.value == true || binding.value == undefined) {
      el.focus();
    }
  },
});
Vue.use(SlideVerify);
Vue.config.ignoredElements = ['wx-open-launch-weapp']
VueCookies.config('15d', null, window.location.host.search('localhost') > -1 ? '' : window.location.host.search('chinagp.net') > -1 ? '.chinagp.net' : '.gp519.com');
router.beforeEach((to, from, next) => {
  if (to.meta.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords);
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description);
    meta.content = to.meta.content;
    head[0].appendChild(meta);
  }

  if (to.meta.title) {
    document.title = to.meta.title;
  }else{
    document.title = "全科医学网"
  }

  if (to.meta.requireAuth) {
    if (localStorage.getItem('ResData')) {
      next();
    } else {
      if (to.path == '/journalxml') {
        next({
          path: '/loginIndex/login',
          query: { callback: to.path },
        });
      } else {
        next({
          path: '/loginIndex/login',
        });
      }
    }
  } else {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
    if (flag) {
      if (
        to.path.toLowerCase().search('meetingMobile'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('meetingpc'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('meetingPc'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('meetingMobileDetail'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('wxlogin'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('queryList'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('queryDetail'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('reading'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('popsci'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('mologin'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('livelist'.toLowerCase()) > -1 ||
        to.path.toLowerCase().search('xcx'.toLowerCase()) > -1
      ) {
        next();
      } else if (to.path.search('/journal') > -1) {
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/magazine/index';
      } else if (to.path.search('Inforlist/inforDetails') > -1 || to.path.search('home/inforDetails') > -1 ) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/home/post?' + params + '&url=%2Fpages%2Fhome%2Findex';
      } else if (to.path.search('Inforlist') > -1) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        params = params.replace(/cid/, 'id');
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/home/list?' + params;
      } else if (to.path.search('magazinejournal/magazinejournaldetail') > -1) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/magazine/detail?' + params + '&url=%2Fpages%2Fmagazine%2Findex';
      } else if (to.path.indexOf('expertsDetail') > 0) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/expert/detail/detail?' + params;
      } else if (to.path.search('experts') > -1) {
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/expert/list/list';
      } else if (to.path.indexOf('organization') > 0) {
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/organ/list/list';
      } else if (to.path.indexOf('organDetail') > 0) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/organ/detail/detail?' + params;
      } else if (to.path.indexOf('loginIndex/loginRegister') > 0) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        if (params != 'undefined') {
          window.location.href = httphelper.IsDebugH5GP519() + '/pages/login/register';
        } else {
          window.location.href = httphelper.IsDebugH5GP519() + '/pages/login/register?' + params;
        }
      } else if (to.path.indexOf('loginIndex/login') > 0) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        if (params != 'undefined') {
          window.location.href = httphelper.IsDebugH5GP519() + '/pages/login/login';
        } else {
          window.location.href = httphelper.IsDebugH5GP519() + '/pages/login/login?' + params;
        }
      } else if (to.path.indexOf('enterprise/qyhome') > 0) {
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/home/project2?id=' + to.query.SpecialID;
      } else if (to.path.indexOf('enterprise/enterpriseDetail') > 0) {
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/home/pro2detail?sid=' + to.query.SpecialID + '&id=' + to.query.id;
      } else if (to.path.indexOf('huodeLive') > 0 || to.path.indexOf('muduLive') > 0 || to.path.indexOf('channelList') > 0) {
        next();
      } else if (to.path.indexOf('question') > 0 || to.path.indexOf('test') > 0 || to.path.indexOf('mcourse') > 0) {
        next();
      } else if (window.location.host.search('meeting.gp519') > -1 || window.location.host.search('meetingtest.gp519') > -1) {
        next();
      } else if (to.path.indexOf('home/specialRecomme') > 0) {
        var params = window.location.href.split('?').length > 0 ? window.location.href.split('?')[1] : window.location.href.split('?')[0];
        window.location.href = httphelper.IsDebugH5GP519() + '/pages/home/project1?' + params;
      } else {
        window.location.href = httphelper.IsDebugH5GP519();
      }
    } else {
      // http://192.168.0.129:8080/ 杂志 ：https://chinagp.net/
      // http://localhost:8080 主站：https://gp519.com/
      if (to.name == 'home' && window.location.host.search('chinagp.net') > -1 && Object.keys(to.query).length == 0) {
        // if (to.name == 'home' && window.location.host.search('192.168.0.129:8080') > -1 && Object.keys(to.query).length == 0) {
        next({
          path: 'magazine',
        });
      } else if (to.name != 'magazine' && window.location.host.search('chinagp.net') > -1 && to.path.search('magazine') < 0) {
        // else if (to.name != 'magazine' && window.location.host.search('192.168.0.129:8080') > -1 && to.path.search('magazine') < 0) {
        window.location.href = httphelper.IsDebugGP519() + to.path;
        // window.location.href = 'http://localhost:8080' + to.path;
      } else if (to.name == 'magazine' && window.location.host.search('gp519.com') > -1) {
        // else if (to.name == 'magazine' && window.location.host.search('localhost:8080') > -1) {
        window.location.href = 'https://chinagp.net/' + to.name;
        // window.location.href = 'http://192.168.0.129:8080/' + to.name;
      } else if (to.name == 'feed') {
        window.location.href = 'https://chinagp.net/' + to.path;
      } else {
        next();
      }
    }
  }
});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app');
